
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import SubKeyCreate from "@/components/keys/SubKeyCreate.vue";
import { Getter } from "vuex-class";
import AddBtn from "@/components/generic/buttons/add-btn.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: { AddBtn, SubKeyCreate, KeyStatus },
})
export default class SubKeysTable extends Vue {

  get canCreateSubKey(): boolean {
    return this.hasRight("CREATE_KEYS");
  }
  get isArchived(): boolean {
    return !!this.currentKey?.archivedAt;
  }
  get isCompanyBlocked(): boolean {
    return !!this.currentKey?.company?.blockedAt;
  }

  @Prop({default: null})
  public currentKey: any;

  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private subKeys: any[] = [];
  private subkeysHeaders: object[] = [];
  private subKeysCount: number = 0;
  private subKeysPagination: any = {
    select: [],
    page: 1,
    itemsPerPage: 10,
  };
  private subKeysSearch: string = "";
  private showArchivedKeys: boolean = false;

  private modaleSubKey: boolean = false;
  private loadingSubKeys: boolean = false;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("subKeysPagination")
  public handlerSubKeyPagination(val, oldVal) {
    if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
      this.getSubKeys();
    }
  }
  @Watch("showArchivedKeys")
  public handlerShowArchivedKeys(val, oldVal) {
      this.getSubKeys();
  }

  private mounted() {
    this.subkeysHeaders = [
      {value: "number", sortable: false},
      {value: "name", text: this.$tc("key.name"), sortable: true},
      {value: "description", text: this.$t("key.description"), sortable: true},
      {value: "status", text: this.$t("key.status"), sortable: true},
      {value: "createdAt", text: this.$t("key.createdOn"), sortable: true},
    ];
    this.getSubKeys();
  }

  private async getSubKeys(): Promise<void> {
    this.loadingSubKeys = true;
    await this.$store.dispatch("keys/getSubKeys", {
      id: this.currentKey.id,
      params: {
        ...this.subKeysPagination,
        search: this.subKeysSearch,
        archived: this.showArchivedKeys,
      },
    }).then((res) => {
      this.subKeys = res.subKeys;
      this.subKeysCount = res.count;
    }).finally(() => {
      this.loadingSubKeys = false;
      this.$emit("loaded");
    });
  }

  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.getSubKeys();
    }
  }

  private subKeyRowClick(subKey, event): any {
    this.$router.push({ name: "key", params: { id: subKey.id } });
  }

  private hasRight(right: string): boolean {
    return this.canDoInEnvCompany(right);
  }

  private createdSubKeys(): void {
    this.getSubKeys();
    this.modaleSubKey = false;
  }
}
